import { render, staticRenderFns } from "./SensorIcon.vue?vue&type=template&id=0bca0eaf&scoped=true&"
import script from "./SensorIcon.vue?vue&type=script&lang=js&"
export * from "./SensorIcon.vue?vue&type=script&lang=js&"
import style0 from "./SensorIcon.vue?vue&type=style&index=0&id=0bca0eaf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca0eaf",
  null
  
)

export default component.exports